import versionInfo from '../version.json';

export function appVersion() {
  return versionInfo.version || '1.0.0-dev';
}